import { getFrom } from "lib/redirects"

export const isSubscriptionUrl = (router) => {
	return getFrom(router.route).split("/")[1] === "subscription"
}
